// extracted by mini-css-extract-plugin
export default {"headerlogo":"index_headerlogo_P5fsD","position":"index_position_I5N8Y","adTips":"index_adTips_KN-2Y"};